import React from "react"
import styled from "styled-components"
import { IC } from "../../resources/Assets"

const Wrap = styled.aside`
display: flex;
justify-content: center;

`

const Button = styled.div`
  width: 320px;
  height: 44px;
  background-color: #0225FF;
  border-radius: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 4px 10px 4px 20px;
  box-sizing: border-box;
  font-size: 14px;
`
const Text = styled.span`
  flex: 2; 
  color: white;
  font-weight: 400;
`
const Buy = styled.div`
  flex: 1;
  display: block;
  background: white;
  border-radius: 20px;
  height: 100%;
  color: #0225FF;
  display: flex;
  align-items: center;
  padding: 13px 15px;
  box-sizing: border-box;
  max-width: 102px;
  position: relative;
`
const BuyText = styled.span`
  font-size: 16px;
  margin-right: 14px;
  font-weight: 600;
`
const BuyIcon = styled.img`
  width:28px;
  height: 36px;
`

const AutoBp = (props) =>{
  return (
    <Wrap>
      <Button onClick={()=>{
        props.click && props.click();
      }}>
        <Text>혈압을 자동으로 입력해보세요~ </Text>
        <Buy>        
          <BuyText>구매</BuyText>
          <BuyIcon src={IC.bp.IC_BUY_ANIMATION} />
          </Buy>
      </Button>
    </Wrap>
  )
}

export default AutoBp